
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import ApprovalListTable from './ApprovalListTable';
import ApprovalApproveModal from './ApprovalApproveModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'ApprovalListModal',
  components: {
    ApprovalApproveModal,
    ApprovalListTable,
  },
})
export default class ApprovalListModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
